<template>
  <b-modal
    ref="update-pititim-price"
    id="update-pititim-price"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
  >
    <h4 class="purple mb-4">
      Atualizar preço Pititim
    </h4>

    <b-row>
      <b-col md="4" class="mt-4">
        <StandardInput
          :value="calendarLabel"
          type="text"
          name="Calendário"
          label="Calendário"
          :disabled="true"
        />
      </b-col>
      <b-col md="4" class="mt-4">
        <label>Preço por módulo</label>
        <CurrencyInput
          :value="selectedPrice.price"
          @input="selectedPrice.price = $event"
        />
      </b-col>
      <b-col md="4" class="mt-4">
        <label>Taxa de material</label>
        <CurrencyInput v-model="selectedPrice.material_fee" />
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <label class="discounts-label">Descontos por módulo</label>
        <div class="discounts-table">
          <div class="discounts-header">
            <div class="discounts-col-module">Módulo</div>
            <div class="discounts-col-discount">Desconto (%)</div>
            <div class="discounts-col-value">Valor mensal</div>
          </div>
          <div
            v-for="(discount, index) in selectedPrice.discounts"
            :key="index"
            class="discounts-row"
          >
            <div class="discounts-col-module">
              <span class="module-number">{{ discount.modules }}</span>
            </div>
            <div class="discounts-col-discount">
              <input
                v-model.number="discount.discount"
                type="number"
                class="form-control"
                step="1"
                min="0"
                max="100"
                placeholder="0"
                @input="autoFillDiscounts(index)"
              />
            </div>
            <div class="discounts-col-value">
              {{ formatBRL(calculateMonthly(discount.modules, discount.discount)) }}
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col>
        <b-button class="btn large outline" @click="hideModal()">
          Voltar
        </b-button>
      </b-col>
      <b-col>
        <b-button
          id="del-btn"
          class="btn large blue"
          @click="deletePrice(selectedPrice.id)"
        >
          Deletar
        </b-button>
      </b-col>
      <b-col class="text-right">
        <b-button class="btn large blue" @click="update(selectedPrice.id)">
          Salvar
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import StandardInput from "@/components/inputs/StandardInput.vue";
import CurrencyInput from "@/components/inputs/CurrencyInput.vue";
import pititimPricesService from "@/services/pititim-prices.service";
import { formatBRL } from "@/utils/formatBRL";
import { calculateMonthlyPititimPrice } from "@/utils/pititimPrice";

export default {
  name: "UpdatePititimPrice",
  components: {
    StandardInput,
    CurrencyInput,
  },
  props: {
    calendar: {
      type: [Object, String, Number, Date],
      default: null,
    },
    price: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedPrice: {
        id: null,
        calendar_id: null,
        calendarName: "",
        price: 0,
        material_fee: null,
        discounts: [],
      },
    };
  },

  computed: {
    calendarLabel() {
      const priceCalendar = this.price
        ? this.price.calendarName ||
          this.price.calendar_name ||
          this.price.Calendar ||
          this.price.calendar
        : null;
      const priceCalendarLabel = this.formatCalendarLabel(priceCalendar);
      const selectedCalendarLabel = this.formatCalendarLabel(this.calendar);
      const priceCalendarId =
        this.price && this.price.calendar_id !== undefined
          ? this.price.calendar_id
          : this.getCalendarId(priceCalendar);
      const selectedCalendarId = this.getCalendarId(this.calendar);

      if (
        priceCalendarId !== null &&
        selectedCalendarId !== null &&
        String(priceCalendarId) !== String(selectedCalendarId)
      ) {
        return "";
      }

      return selectedCalendarLabel || priceCalendarLabel;
    },
  },

  watch: {
    price() {
      if (this.price) {
        this.selectedPrice = {
          material_fee: null,
          ...JSON.parse(JSON.stringify(this.price)),
        };
        // Ensure all 10 module discount rows exist
        this.ensureAllDiscountRows();
      } else {
        this.selectedPrice = {
          id: null,
          calendar_id: null,
          calendarName: "",
          price: 0,
          material_fee: null,
          discounts: [],
        };
      }
    },
  },

  methods: {
    formatBRL,

    formatCalendarLabel(calendar) {
      if (calendar === null || calendar === undefined || calendar === "") {
        return "";
      }

      if (calendar instanceof Date) {
        return isNaN(calendar.getTime()) ? "" : String(calendar.getFullYear());
      }

      if (typeof calendar === "object") {
        return this.formatCalendarLabel(
          calendar.name ||
            calendar.designation ||
            calendar.date ||
            calendar.start_date
        );
      }

      const value = String(calendar);
      const apiDate = value.match(
        /^(\d{4})-\d{2}-\d{2}(?:(?:T| )\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?)?$/
      );

      return apiDate ? apiDate[1] : value;
    },

    getCalendarId(calendar) {
      if (!calendar || typeof calendar !== "object" || calendar instanceof Date) {
        return null;
      }

      return calendar.id !== undefined
        ? calendar.id
        : calendar.calendar_id !== undefined
        ? calendar.calendar_id
        : null;
    },

    calculateMonthly(modules, discount) {
      return calculateMonthlyPititimPrice(modules, this.selectedPrice.price, discount);
    },

    /**
     * Ensure the discounts array always has exactly 10 rows (modules 1-10).
     * If the API returns fewer, fill the rest with discount: 0.
     */
    ensureAllDiscountRows() {
      const existingModules = new Set(
        this.selectedPrice.discounts.map((d) => d.modules)
      );
      for (let i = 1; i <= 10; i++) {
        if (!existingModules.has(i)) {
          this.selectedPrice.discounts.push({ modules: i, discount: 0 });
        }
      }
      this.selectedPrice.discounts.sort((a, b) => a.modules - b.modules);
    },

    autoFillDiscounts(index) {
      if (index !== 0) return;
      const pattern = [0, 25, 35, 45, 50, 52, 54, 56, 58, 60];
      for (let i = 1; i < this.selectedPrice.discounts.length; i++) {
        this.selectedPrice.discounts[i].discount = pattern[i];
      }
    },

    async deletePrice(priceId) {
      if (!priceId) {
        this.$swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Não foi possível deletar o preço.",
        });
        return;
      }

      const result = await this.$swal.fire({
        title: "Tem certeza?",
        text: "Deseja deletar este preço Pititim?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#eb5757",
        cancelButtonColor: "#b3b3b3",
        confirmButtonText: "Sim, deletar",
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        try {
          await pititimPricesService.delete(priceId);

          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: "Preço removido com sucesso!",
          });

          this.hideModal();
          window.location.reload();
        } catch (error) {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possível deletar o preço.",
          });
        }
      }
    },

    async update(id) {
      if (!id) {
        this.$swal.fire({
          icon: "warning",
          title: "Atenção",
          text: "Não foi possível atualizar o preço.",
        });
        return;
      }

      if (!this.selectedPrice.price || this.selectedPrice.price <= 0) {
        return this.$swal.fire({
          icon: "warning",
          title: "Campo inválido",
          text: "O preço por módulo deve ser um número maior que zero.",
        });
      }

      // Validate all 10 discount rows
      if (
        !this.selectedPrice.discounts ||
        this.selectedPrice.discounts.length !== 10
      ) {
        return this.$swal.fire({
          icon: "warning",
          title: "Campo inválido",
          text: "Todos os 10 descontos devem estar preenchidos.",
        });
      }

      const invalidDiscount = this.selectedPrice.discounts.find(
        (d) =>
          d.discount < 0 || d.discount > 100 || !Number.isInteger(d.discount)
      );

      if (invalidDiscount) {
        return this.$swal.fire({
          icon: "warning",
          title: "Campo inválido",
          text: "Os descontos devem ser números inteiros entre 0 e 100.",
        });
      }

      const data = {
        price: this.selectedPrice.price,
        material_fee: this.selectedPrice.material_fee || null,
        discounts: this.selectedPrice.discounts.map((d) => ({
          modules: d.modules,
          discount: d.discount,
        })),
      };

      try {
        await pititimPricesService.update(id, data);

        const Toast = this.$swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: "Preço atualizado com sucesso!",
        });

        this.hideModal();
        window.location.reload();
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Não foi possível atualizar o preço.";

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: message,
        });
      }
    },

    hideModal() {
      this.$refs["update-pititim-price"].hide();
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

div#update-pititim-price {
  .modal-dialog {
    max-width: 820px;
    .modal-content {
      background-color: $grey2;
      border: 0;
      border-radius: 12px;
      .modal-body {
        padding: 40px;
      }
    }
  }

  h4.purple {
    color: $purple;
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 2px solid $grey5;
  }

  label {
    display: block;
    margin-bottom: 6px;
    font-weight: 600;
    color: #495057;
    font-size: 14px;
  }

  #del-btn {
    background-color: $purple;
    border-color: $purple;
    color: white;

    &:hover {
      background-color: white;
      border-color: $purple;
      color: $purple;
    }
  }

  .discounts-label {
    font-weight: 600;
    color: #495057;
    font-size: 14px;
  }

  .discounts-table {
    width: 100%;
    max-width: 400px;
  }

  .discounts-header {
    display: flex;
    padding: 8px 0;
    border-bottom: 2px solid $grey5;

    .discounts-col-module,
    .discounts-col-discount,
    .discounts-col-value {
      font-weight: 600;
      font-size: 14px;
      color: #495057;
    }
  }

  .discounts-row {
    display: flex;
    align-items: center;
    padding: 6px 0;
    border-bottom: 1px solid #e7e8ec;

    &:last-child {
      border-bottom: none;
    }
  }

  .discounts-col-module {
    width: 120px;
    display: flex;
    align-items: center;
  }

  .module-number {
    font-weight: 600;
    color: #495057;
  }

  .discounts-col-discount {
    flex: 1;

    .form-control {
      border-radius: 4px;
      border: 1px solid #ced4da;
      padding: 6px 10px;
      font-size: 14px;
      width: 100%;
      max-width: 120px;

      &:focus {
        border-color: $purple;
        outline: none;
        box-shadow: 0 0 0 0.2rem rgba($purple, 0.15);
      }
    }
  }

  .discounts-col-value {
    width: 120px;
    text-align: right;
    font-weight: 600;
    font-size: 14px;
    color: $green3;
    padding-right: 8px;
  }
}
</style>
